import { render, staticRenderFns } from "./BaseTooltipIcon.vue?vue&type=template&id=059bb0fa"
import script from "./BaseTooltipIcon.vue?vue&type=script&lang=js"
export * from "./BaseTooltipIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports